import { render, staticRenderFns } from "./uiExplain.vue?vue&type=template&id=5062e42c&scoped=true&"
import script from "./uiExplain.vue?vue&type=script&lang=js&"
export * from "./uiExplain.vue?vue&type=script&lang=js&"
import style0 from "./uiExplain.vue?vue&type=style&index=0&id=5062e42c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5062e42c",
  null
  
)

export default component.exports